<div class="text-center" *ngIf="loading">
  <i class="fas fa-spinner fa-pulse fa-3x"></i>
</div>
<div>
  <div class="row py-3 my-2 mx-2">
    <div class="col-4">
      <div class="form-group">
        <label>Bill Type</label>
        <select class="form-control" name="bill_type_id" ngDefaultControl [(ngModel)]="search_params.bill_type_id">
          <option *ngFor="let billType of search_options.bill_types" [value]="billType.value">{{ billType.label }}</option>
        </select>
      </div>
    </div>
    <div class="col-4">
      <div class="form-group">
        <label>Amount</label>
        <input type="number" class="form-control" name="amount" ngDefaultControl [(ngModel)]="search_params.amount" />
        <div class="row">
          <div class="col-6">
            <div class="custom-control custom-radio custom-control-inline" (click)="search_params.amount_comparison = '&lt;'">
              <input type="radio" name="amount_comparison" ngDefaultControl [checked]="search_params.amount_comparison == '&lt;'" class="custom-control-input" />
              <label class="custom-control-label">Less than</label>
            </div>
            <div class="custom-control custom-radio custom-control-inline" (click)="search_params.amount_comparison = '&gt;'">
              <input type="radio" name="amount_comparison" ngDefaultControl [checked]="search_params.amount_comparison == '&gt;'" class="custom-control-input" />
              <label class="custom-control-label">Greater than</label>
            </div>
          </div>
          <div class="col-6">
            <div class="custom-control custom-radio custom-control-inline" (click)="search_params.amount_comparison = '='">
              <input type="radio" name="amount_comparison" ngDefaultControl [checked]="search_params.amount_comparison == '='" class="custom-control-input" />
              <label class="custom-control-label">Equals</label>
            </div>
            <div class="custom-control custom-radio custom-control-inline" (click)="search_params.amount_comparison = ''">
              <input type="radio" name="amount_comparison" ngDefaultControl [checked]="search_params.amount_comparison == ''" class="custom-control-input" />
              <label class="custom-control-label">Any</label>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="col-4">
      <div class="form-group">
        <label>Pages</label>
        <pagination
          (pageChanged)="loadBills($event)"
          class="pagination-sm"
          [boundaryLinks]="true"
          [totalItems]="count"
          [maxSize]="5"
          [(ngModel)]="search_params.page"
          [itemsPerPage]="search_params.per_page"
          previousText="&lsaquo;"
          nextText="&rsaquo;"
          firstText="&laquo;"
          lastText="&raquo;"
        ></pagination>
      </div>
    </div>
  </div>
  <div class="row mx-2">
    <div class="col-8">
      <div class="form-group">
        <label class="w-100 text-center">Date Range</label>
        <button type="button" class="btn btn-outline-secondary btn-block" id="reportrange">{{ datePickerLabel }}&nbsp; <i class="fas fa-calendar-alt"></i>&nbsp; <span></span> <b class="caret float-right"></b></button>
      </div>
    </div>
    <div class="col-4 text-left">
      <div class="form-group">
        <label class="text-white">Search</label><br />
        <button type="button" (click)="loadBills()" class="btn btn-primary" [disabled]="searching">
          {{ searching ? 'Searching' : 'Search' }}<span *ngIf="searching">&nbsp;<i class="fas fa-spinner fa-fw fa-pulse"></i></span>
        </button>
        &nbsp;
        <button type="button" (click)="resetSearch()" class="btn btn-secondary" [disabled]="searching">Reset</button>
      </div>
    </div>
  </div>
  <div class="row" *ngIf="matter_id">
    <div class="col-1 text-center"><h5>Id</h5></div>
    <div class="col-1 text-center"><h5>Invoice</h5></div>
    <div class="col-1 text-center"><h5>Date</h5></div>
    <div class="col-4"><h5>Description</h5></div>
    <div class="col-2"><h5>Charged By</h5></div>
    <div class="col-1 text-center"><h5>Amount</h5></div>
    <div class="col-2"><h5>Paid?</h5></div>
  </div>
  <div *ngIf="matter_id">
    <div class="row py-3 odd-color-mute" *ngFor="let bill of bills" style="font-size: 85%">
      <div class="col-1 text-center">
        <a [href]="'/bills/' + bill.id">{{ bill.id }}</a>
      </div>
      <div class="col-1 text-center">
        <a [href]="'/invoices/' + bill.invoice_id" *ngIf="bill.invoice_id > 0">{{ bill.invoice_id }}</a>
      </div>
      <div class="col-1 text-center" [title]="bill.created_at_time" [tooltip]="bill.created_at_time">
        {{ bill.created_at_date }}
      </div>
      <div class="col-4" [innerHTML]="bill.description | safeHtml"></div>
      <div class="col-2">
        {{ bill.user_name }}
      </div>
      <div class="col-1 text-right">
        {{ bill.amount | currency: 'USD':'symbol-narrow':'1.2-2' }}
      </div>
      <div class="col-2">
        <span *ngIf="bill.is_paid"><img [src]="search_options.coins_asset" /></span>
      </div>
    </div>
  </div>
</div>
